import { Outlet } from "react-router-dom";
import MainNavigation from "../components/Navigation/MainNavigation";
import InstallPrompt from "../components/InstallPrompt/InstallPrompt.tsx";

const AppScreensLayout = () => {
  return (
    <>
      <main className="h-[calc(100%-63px)]">
        <Outlet />
      </main>
      <MainNavigation />
      <InstallPrompt />
    </>
  );
};

export default AppScreensLayout;
